'use strict';

angular.module('schoolbushubApp')
    .factory('Student', function ($resource, DateUtils) {
        return $resource('api/students/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateOfBirth = DateUtils.convertLocaleDateFromServer(data.dateOfBirth);
                    return data;
                }
            },
            'filterQuery': { method: 'POST', url: 'api/students/query', isArray:true },
            'filterVars': { method: 'GET', url: 'api/students/info', isArray:true },
            'update': { method:'PUT' }
        });
    });
